import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const distributorIsDsMarketing =
  !location.hostname.toLowerCase().includes("smart") ||
  !location.hostname.toLowerCase().includes("pas") ||
  !location.hostname.toLowerCase().includes("bombeef") ||
  !location.hostname.toLowerCase().includes("linkedby") ||
  !location.hostname.toLowerCase().includes("adnotify");

const TextFieldLogin = styled(MuiTextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    color: distributorIsDsMarketing ? "#FFF" : undefined,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    fontSize: "14px",
    lineHeight: "20px",
  },
  "& label.Mui-focused": {
    color: distributorIsDsMarketing ? "#FFF" : undefined,
  },
  "& .MuiFormLabel-root": {
    color: distributorIsDsMarketing ? "#FFF" : undefined,
  },
  "& .MuiInput-underline:after": { borderBottomColor: "#585A66" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: distributorIsDsMarketing ? "#FFF" : undefined,
    },
    "&:hover fieldset": {
      borderColor: distributorIsDsMarketing ? "#FFF" : undefined,
    },
    "&.Mui-focused fieldset": {
      border: distributorIsDsMarketing ? "1.5px solid #FFF" : undefined,
    },
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#585A66",
  },
  "& .MuiFormLabel-root.Mui-disabled": {
    WebkitTextFillColor: "#585A66",
  },
}));

export default TextFieldLogin;
